import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { useGetAllProductDetailsQuery } from '../../api/product/productApiSlice';
import { historyActions } from './redux/history.redux';

interface Props {
    setSelectedProductIds: (ids: string[]) => void;
}

const mapToOption = ({ sku, name }: { sku: string; name: string }) => ({ id: sku, label: name, text: name });

const ProductSelect = ({ setSelectedProductIds }: Props) => {
    const intl = useIntl();
    const { data: products } = useGetAllProductDetailsQuery();
    const activeProducts = products?.filter(({ legacy }) => !legacy).map(mapToOption);
    const legacyProducts = products?.filter(({ legacy }) => legacy).map(mapToOption);
    const productOptions = products
        ? [
              ...(activeProducts ?? []),
              { id: 'leg', label: intl.formatMessage({ id: 'intl-msg:marketplace.products.old' }), header: true },
              ...(legacyProducts ?? []),
          ]
        : undefined;

    return (
        <Multiselect
            className={'max-width-500'}
            placeholder={intl.formatMessage({ id: 'intl-msg:marketplace.history.service.select.placeholder' })}
            options={productOptions}
            onChange={(ids: string[]) => setSelectedProductIds([...ids])}
        />
    );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setSelectedProductIds: (ids: string[]) => dispatch(historyActions.setSelectedProductIds(ids)),
});

export const ProductSelectContainer = connect(null, mapDispatchToProps)(ProductSelect);
